(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/start-game-by-loader.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/start-game-by-loader.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  hostKey,
  lotteryCode,
  itf,
  neo
} = svs.ticketUtility && svs.ticketUtility.data.gameloaderHelperConfig || {};
const getAccessCode = async () => {
  try {
    const domain = window.location.origin;
    const path = "".concat(svs.core.urlMapping.get('ticketsApi'), "/accesscode");
    const response = await fetch("".concat(domain).concat(path));
    if (!response.ok) {
      throw new Error();
    }
    const data = await response.json();
    return data.accessCode;
  } catch (e) {
    svs.tur.apierrors.showErrorMessage({
      response: 0,
      onConfirm: () => svs.utils.url.navigate(svs.core.data.baseUrl)
    });
    throw new Error('Failed to fetch access code');
  }
};
const getFGSBridgeParameters = _ref => {
  var _gameSpecificParamete;
  let {
    gameSpecificParameters,
    gameContext,
    soundEnabled
  } = _ref;
  const {
    WEB,
    VOUCHER
  } = svs.ticketgames.ticketUtility.utils.constants.leia.lotteryChannel;
  const {
    ticketInfo: {
      gameLoader,
      theme
    },
    isDemo,
    betId = undefined,
    voucherCode = null,
    isEInstant = false
  } = gameContext;
  const lotteryChannel = svs.ticketgames.ticketMappings.channelMappings.getChannel(voucherCode ? VOUCHER : WEB, svs.core.data.capabilities.channel);
  if ((_gameSpecificParamete = gameSpecificParameters) !== null && _gameSpecificParamete !== void 0 && _gameSpecificParamete.skinId) {
    gameSpecificParameters = _objectSpread(_objectSpread({}, gameSpecificParameters), {}, {
      skinId: svs.ticketgames.ticketUtility.utils.normalizeSkinId(gameSpecificParameters.skinId)
    });
  }
  return {
    crossDomain: {
      hostKey,
      authorizedHosts: [window.location.host]
    },
    gameloader: {
      url: itf === null || itf === void 0 ? void 0 : itf.url,
      name: gameLoader,
      betId,
      gameMode: isDemo ? 'DEMO' : 'NORMAL',
      lotteryChannel,
      gameSpecificParameters: _objectSpread(_objectSpread({}, gameSpecificParameters), {}, {
        lockProgress: svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)
      }),
      theme: isEInstant ? null : theme,
      soundEnabled
    }
  };
};
const getNEORgsParameters = async _ref2 => {
  let {
    gameContext,
    soundEnabled
  } = _ref2;
  const {
    WEB
  } = svs.ticketgames.ticketUtility.utils.constants.leia.lotteryChannel;
  const lotteryChannel = svs.ticketgames.ticketMappings.channelMappings.getChannel(WEB, svs.core.data.capabilities.channel);
  const {
    ticketInfo: {
      gameLoader,
      type: GameCode
    },
    isDemo: IsDemoMode,
    betId
  } = gameContext;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  let accessCode = null;
  if (isLoggedIn) {
    accessCode = await getAccessCode();
  }
  return {
    crossDomain: {
      hostKey,
      authorizedHosts: [window.location.host]
    },
    gameloader: {
      url: neo === null || neo === void 0 ? void 0 : neo.url,
      name: gameLoader,
      betId,
      gameMode: IsDemoMode ? 'DEMO' : 'NORMAL',
      lotteryChannel,
      soundEnabled,
      gameSpecificParameters: {
        AuthorizationCode: accessCode,
        IsDemoMode,
        GameCode,
        CurrencyCode: 'SEK',
        LanguageCode: 'sv-SE',
        CountryCode: 'SE',
        LotteryCode: lotteryCode,
        HomeUrl: '',
        CashierUrl: ''
      }
    }
  };
};
setGlobal('svs.ticketgames.ticketUtility.components.startGameByLoader', _ref3 => {
  var _gameContext$ticketIn, _svs$ticketgames$tick;
  let {
    gameSpecificParameters,
    gameContext,
    soundEnabled,
    onDone
  } = _ref3;
  const {
    FGS_BRIDGE,
    NEO_RGS
  } = svs.ticketgames.ticketUtility.utils.constants.leia.GAME_LOADERS;
  const gameLoader = (_gameContext$ticketIn = gameContext.ticketInfo) === null || _gameContext$ticketIn === void 0 ? void 0 : _gameContext$ticketIn.gameLoader.toUpperCase();
  (_svs$ticketgames$tick = svs.ticketgames.ticketUtility) === null || _svs$ticketgames$tick === void 0 || _svs$ticketgames$tick.loadGameloaderHelper.then(() => {
    switch (gameLoader) {
      case FGS_BRIDGE:
        onDone(getFGSBridgeParameters({
          gameSpecificParameters,
          gameContext,
          soundEnabled
        }));
        return;
      case NEO_RGS:
        getNEORgsParameters({
          gameContext,
          soundEnabled
        }).then(onDone);
        return;
      default:
        throw new Error("Unsupported gameLoader: ".concat(gameLoader));
    }
  });
});

 })(window);